const equals =
  (word: string) =>
  (value: string): string | undefined =>
    String(value).toUpperCase() !== String(word).toUpperCase() ? 'Something looks odd.' : undefined;

export default equals;
